import Flickity from 'flickity/dist/flickity.pkgd.js';

'use strict';

var NAME           = 'banner';
var NAMESPACE      = 'hogo.' + NAME;
var SELECTOR       = '[data-' + NAME + ']';

var $body = $(document.body);


/**
 * Constructor.
 *
 * @param  {DOMElement|string}  element
 * @param  {object}             options
 */
const Banner = function (el, options) {
	this.$element = $(el);
	this.options = $.extend({}, Banner.DEFAULTS, options);
	this.updateOptions();

	this.initiateFlickity();
};

/**
 * Autocomplete version.
 */
Banner.VERSION = '0.1.0';

/**
 * Autocomplete component defaults.
 */
Banner.DEFAULTS = {
    autoPlay: 3000,
    arrowShape: 'M 0,50 L 80,00 L 80,100 Z',
    pageDots: false,
    flexHeight: .4,
    wrapAround: false,
    selectedAttraction: 0.01,
    friction: 0.15
};

/**
 * Initiate Flickity.
 */
Banner.prototype.initiateFlickity = function ()
{
	this.$flickity = new Flickity(this.$element[0], this.options);
};

/**
 * Override current options with options found as data attributes.
 */
Banner.prototype.updateOptions = function ()
{
	var $el = this.$element;
	if ($el.data('flex-height') !== undefined) {
		this.options.flexHeight = $el.data('flex-height');
	}
	if ($el.data('autoplay') !== undefined) {
		this.options.autoPlay = $el.data('autoplay');
	}
	if ($el.data('page-dots') !== undefined) {
		this.options.pageDots = $el.data('page-dots');
	}
    if ($el.data('wrap-around') !== undefined) {
        this.options.wrapAround = $el.data('wrap-around');
    }
    if ($el.data('selected-attraction') !== undefined) {
        this.options.selectedAttraction = $el.data('selected-attraction');
    }
	if ($el.data('friction') !== undefined) {
		this.options.friction = $el.data('friction');
	}
};

/**
 * Resize the banner.
 */
Banner.prototype.onResize = function ()
{
	if (this.options.flexHeight) {
    	var wh = $(window).height();
    	this.$element.height(wh * this.options.flexHeight);
    }
};


// AUTOCOMPLETE PLUGIN DEFINITION
// ==============================

function Plugin (option)
{
    var args = [];
    for (var i = 1; i < arguments.length; i++) {
        args.push(arguments[i]);
    }

    return this.each(function () {
        var $this = $(this);
        var options = $.extend({}, Banner.DEFAULTS, $this.data(), typeof option == 'object' && option)

        var data  = $this.data(NAMESPACE);

        if ( ! data) $this.data(NAMESPACE, (data = new Banner(this, options)));
        if (typeof option === 'string') data[option].apply(data, args);
    });
}

$.fn.banner             = Plugin;
$.fn.banner.Constructor = Banner;


// APPLY TO STANDARD DATE SELECT ELEMENTS
// ======================================

$(SELECTOR).banner();


// BIND EVENTS
// ===========

$(window)
    // Resize the banner whenever the window is.
    .on('resize.' + NAMESPACE, function (e) {
    	var $banner = $(SELECTOR);

    	Plugin.call($banner, 'onResize');
    });



// EXPORT MODULE
// =============

export default Banner;